<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="title-box">
          <div class="title-box-left">
            税筹订单 > 创建订单
          </div>
          <div class="title-box-right">
            <a-button @click="$router.push('/tax/order')">取消</a-button>
          </div>
        </div>
      </template>

      <div class="form-box">
        <!-- 税筹商户选择 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span class="required">税筹商户</span></a-col>
            <a-col :span="20">
              <span class="merchant-display">{{ selectedMerchantName || '请选择税筹商户' }}</span>
              <a-button style="margin-left: 8px;" type="primary" @click="openMerchantDialog">选择商户</a-button>
              <span v-if="selectedMerchant" style="margin-left: 16px; color: #999;">
                商户编号：{{ selectedMerchant.merchantNo }}
              </span>
            </a-col>
          </a-row>
        </div>

        <!-- 支付类型 -->
        <div class="form-box-item" v-if="selectedMerchant">
          <a-row>
            <a-col :span="4"><span class="required">支付类型</span></a-col>
            <a-col :span="20">
              <a-radio-group v-model="payType" @change="onPayTypeChange" button-style="solid">
                <a-radio-button value="TAX_PLAN">税筹支付</a-radio-button>
                <a-radio-button value="BALANCE">余额支付</a-radio-button>
              </a-radio-group>
            </a-col>
          </a-row>
        </div>

        <!-- 付款钱包 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span class="required">付款人</span></a-col>
            <a-col :span="20">
              <!-- 余额支付：下拉选择付款账户 -->
              <template v-if="payType === 'BALANCE'">
                <a-select placeholder="请选择付款账户"
                          v-model="payerValue"
                          @change="onPayerChange"
                          style="min-width: 300px;">
                  <a-select-option v-for="item in payerAccountList"
                                   :key="item.accountNo"
                                   :value="item.accountNo">
                    <WalletInfo :account-name="item.accountName"
                                :account-no="item.accountNo"
                                :show-account-no="false"
                                :show-account-name="true"
                                :is-wallet="true"
                                :show-balance="false">
                    </WalletInfo>
                  </a-select-option>
                </a-select>
                <div v-if="paramsData.accountNo" class="payment-box">
                  <a-descriptions :column="1" bordered size="small" style="margin-top: 8px;">
                    <a-descriptions-item label="付款户名">{{ paramsData.accountName }}</a-descriptions-item>
                    <a-descriptions-item label="付款账号">{{ paramsData.accountNo }}</a-descriptions-item>
                  </a-descriptions>
                </div>
              </template>
              <!-- 税筹支付：商户配置固定付款人 -->
              <template v-else>
                <div v-if="paramsData.accountNo" class="payment-box">
                  <a-descriptions :column="1" bordered size="small" style="margin-top: 8px;">
                    <a-descriptions-item label="付款户名">{{ paramsData.accountName }}</a-descriptions-item>
                    <a-descriptions-item label="付款账号">{{ paramsData.accountNo }}</a-descriptions-item>
                  </a-descriptions>
                </div>
              </template>
            </a-col>
          </a-row>
        </div>


        <!-- 可使用余额 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>可用余额</span></a-col>
            <a-col :span="20">
              <Balance :align-right="false" :amount="balance"></Balance>
            </a-col>
          </a-row>
        </div>

        <!-- 收款人 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span class="required">收款人</span></a-col>
            <a-col :span="20">
              <!-- 余额支付：协议支付下拉选择 -->
              <template v-if="payType === 'BALANCE'">
                <a-select placeholder="请选择收款人"
                          v-model="paymentValue"
                          @change="paymentChange"
                          style="min-width: 300px;"
                          :loading="paymentLoading">
                  <a-select-option v-for="item in paymentList"
                                   :key="item.id"
                                   :value="item.id">
                    <WalletInfo :account-name="item.oppAccountName"
                                :account-no="item.oppAccountNo"
                                :bank-name="item.oppBankName"
                                :bank-no="item.oppBankNo"
                                :show-account-no="false"
                                :show-account-name="true"
                                :is-wallet="item.oppAccountType==='1'"
                                :show-balance="false">
                    </WalletInfo>
                    <a-tag color="red" v-if="item.checkStatus === '0'">待审批</a-tag>
                  </a-select-option>
                </a-select>
                <div class="payment-box" v-if="paymentValue">
                  <a-descriptions :column="1" bordered size="small" style="margin-top: 8px;">
                    <a-descriptions-item label="收款户名">{{ paramsData.oppAccountName }}</a-descriptions-item>
                    <a-descriptions-item label="收款账号">{{ paramsData.oppAccountNo }}</a-descriptions-item>
                    <a-descriptions-item label="开户银行">{{ paramsData.oppBankName || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="开户行号">{{ paramsData.oppBankNo || '-' }}</a-descriptions-item>
                  </a-descriptions>
                </div>
              </template>
              <!-- 税筹支付：商户配置固定收款人 -->
              <template v-else>
                <div v-if="paramsData.oppAccountNo" class="payment-box">
                  <a-descriptions :column="1" bordered size="small" style="margin-top: 8px;">
                    <a-descriptions-item label="收款户名">{{ paramsData.oppAccountName }}</a-descriptions-item>
                    <a-descriptions-item label="收款账号">{{ paramsData.oppAccountNo }}</a-descriptions-item>
                    <a-descriptions-item label="开户银行">{{ paramsData.oppBankName || '-' }}</a-descriptions-item>
                    <a-descriptions-item label="开户行号">{{ paramsData.oppBankNo || '-' }}</a-descriptions-item>
                  </a-descriptions>
                </div>
              </template>
            </a-col>
          </a-row>
        </div>

        <!-- 订单金额 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span class="required">订单金额</span></a-col>
            <a-col :span="20">
              <input-balance v-model="paramsData.totalAmount"
                             :max="maxPayAmount"
                             align-left
                             style="width: 300px;">
              </input-balance>
              <!-- 实时限额校验提示 -->
              <div v-if="limitCheckMsg" class="limit-check-tip"
                   :class="{
                     'pending': limitChecking,
                     'pass': !limitChecking && limitCheckStatus === 'PASS',
                     'warn': !limitChecking && limitCheckStatus === 'WARN',
                     'fail': !limitChecking && limitCheckStatus === 'FAIL'
                   }">
                <a-icon v-if="limitChecking" type="loading"/>
                <a-icon v-else-if="limitCheckStatus === 'PASS'" type="check-circle"/>
                <a-icon v-else-if="limitCheckStatus === 'WARN'" type="exclamation-circle"/>
                <a-icon v-else-if="limitCheckStatus === 'FAIL'" type="close-circle"/>
                <span>{{ limitCheckMsg }}</span>
              </div>
              <!--              <span style="margin-left: 16px; color: #999;">服务费：{{ calculatedServiceFee }} 元</span>-->
            </a-col>
          </a-row>
        </div>

        <!-- 交易摘要 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span>交易摘要</span></a-col>
            <a-col :span="20">
              <a-input v-model="paramsData.remark"
                       placeholder="默认摘要"
                       style="width: 300px;"/>
            </a-col>
          </a-row>
        </div>

        <!-- 验证码 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"><span class="required">验证码</span></a-col>
            <a-col :span="20">
              <payment-sms :account-name="paramsData.accountName"
                           :account-no="paramsData.accountNo"
                           :channel-no="paramsData.channelNo"
                           :disabled="!paramsData.oppAccountNo || Number(paramsData.totalAmount) <= 0"
                           :mobile="mobile"
                           :pay-amount="paramsData.totalAmount"
                           :verify-code.sync="paramsData.verifyCode"
                           model-no="102216"
                           style="width: 300px;">
              </payment-sms>
            </a-col>
          </a-row>
        </div>

        <!-- 确认按钮 -->
        <div class="form-box-item">
          <a-row>
            <a-col :span="4"></a-col>
            <a-col :span="20">
              <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <a-tooltip :title="disabledReason" placement="top">
                  <a-button :disabled="!canSubmit || submitting"
                            :loading="submitting"
                            style="width: 300px;"
                            icon="check-circle"
                            type="primary"
                            @click="onSubmitPay">
                    确认创建
                  </a-button>
                </a-tooltip>
                <a-button icon="clock-circle"
                          style="width: 300px; margin-top: 8px;"
                          type="link"
                          @click="$router.push('/tax/order')">
                  历史订单
                </a-button>
              </div>
            </a-col>
          </a-row>
        </div>

      </div>
      <!-- 商户选择弹窗 -->
      <a-modal
          v-model="merchantDialogVisible"
          :destroyOnClose="true"
          :footer="null"
          title="选择税筹商户"
          width="900px"
      >
        <div class="merchant-search">
          <a-input
              v-model.trim="merchantSearchParam.merchantNo"
              allow-clear
              placeholder="商户编号"
              style="width: 180px; margin-right: 8px;"
          />
          <a-input
              v-model.trim="merchantSearchParam.merchantName"
              allow-clear
              placeholder="商户名称"
              style="width: 180px; margin-right: 8px;"
          />
          <a-button style="margin-right: 8px;" type="primary" @click="searchMerchant">查询</a-button>
          <a-button @click="resetMerchantSearch">重置</a-button>
        </div>

        <a-table
            :columns="merchantColumns"
            :data-source="merchantList"
            :loading="merchantLoading"
            :pagination="merchantPagination"
            :row-key="record => record.id"
            size="small"
            style="margin-top: 16px;"
            @change="handleMerchantTableChange"
        >
          <template slot="action" slot-scope="text, record">
            <a-button type="link" @click="selectMerchant(record)">选择</a-button>
          </template>
        </a-table>
      </a-modal>

      <!-- 确认弹框 -->
      <a-modal :visible="isShowConfirmDialog"
               centered
               title="订单信息确认"
               @cancel="isShowConfirmDialog = false"
               @ok="onConfirmDialog">
        <a-descriptions :column="1" bordered>
          <a-descriptions-item label="税筹商户">{{ selectedMerchant?.merchantName }} ({{ selectedMerchant?.merchantNo }})</a-descriptions-item>
          <a-descriptions-item label="支付类型">{{ payType === 'BALANCE' ? '余额支付' : '税筹支付' }}</a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="1" bordered style="margin-top: 16px;">
          <a-descriptions-item label="付款账户">{{ paramsData.accountName }}</a-descriptions-item>
          <a-descriptions-item label="付款账号">{{ paramsData.accountNo }}</a-descriptions-item>
          <a-descriptions-item label="订单金额">
            <Balance :amount="paramsData.totalAmount" prefix="" suffix="元"/>
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="1" bordered style="margin-top: 16px;">
          <a-descriptions-item label="收款户名">{{ paramsData.oppAccountName }}</a-descriptions-item>
          <a-descriptions-item label="收款账号">{{ paramsData.oppAccountNo }}</a-descriptions-item>
          <a-descriptions-item label="开户银行">{{ paramsData.oppBankName }}</a-descriptions-item>
        </a-descriptions>
        <a-descriptions :column="1" bordered style="margin-top: 16px;">
          <!--          <a-descriptions-item label="服务费">-->
          <!--            <Balance :amount="calculatedServiceFee" prefix="" suffix="元"/>-->
          <!--          </a-descriptions-item>-->
          <a-descriptions-item label="交易摘要">{{ paramsData.remark || '-' }}</a-descriptions-item>
        </a-descriptions>
      </a-modal>
    </a-card>
  </div>

</template>

<script>
import Balance from '@/view/components/Balance.vue'
import InputBalance from "@/view/components/InputBalance.vue";
import PaymentSms from "@/view/components/PaymentSms.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";

export default {
  name: "TaxOrderCreate",
  components: {
    Balance,
    InputBalance,
    PaymentSms,
    WalletInfo,
  },
  data() {
    return {
      paramsData: {
        channelNo: "",
        appNo: "",
        accountNo: "",
        accountName: "",
        custname: "",
        oppAccountType: "",
        oppAccountNo: "",
        oppAccountName: "",
        oppBankNo: "313338707013",
        oppBankName: "浙江稠州商业银行",
        verifyCode: "",
        totalAmount: "",
        remark: "",
      },
      isShowConfirmDialog: false,
      payType: 'TAX_PLAN',
      balance: 0,
      mobile_mch: "",
      payerWalletList: [],
      payerAccountList: [],
      payerValue: undefined,
      paymentList: [],
      paymentValue: undefined,
      paymentLoading: false,
      submitting: false,

      // ====== 商户限额预校验 ======
      limitChecking: false,         // 校验进行中
      limitCheckMsg: '',            // 校验提示
      limitCheckOk: false,          // 校验通过
      limitCheckStatus: '',         // 校验状态: PASS/WARN/FAIL
      limitCheckTimer: null,        // 防抖定时器

      merchantDialogVisible: false,
      merchantLoading: false,
      merchantList: [],
      merchantSearchParam: {
        merchantNo: "",
        merchantName: "",
      },
      merchantPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      selectedMerchant: null,
      selectedMerchantName: "",
      feeRuleList: [],

      merchantColumns: [
        {title: "商户编号", dataIndex: "merchantNo", align: "center", width: 150},
        {title: "商户名称", dataIndex: "merchantName", align: "center", width: 150},
        {title: "个体户账户", dataIndex: "accountNo", align: "center", width: 150},
        {title: "服务费收款方", dataIndex: "feeAccountNo", align: "center", width: 150},
        {title: "操作", key: "action", align: "center", width: 80, scopedSlots: {customRender: 'action'}},
      ],
    };
  },

  computed: {
    mobile() {
      return this.mobile_mch;
    },
    maxPayAmount() {
      return this.balance;
    },
    canSubmit() {
      const base = this.paramsData.totalAmount &&
          this.paramsData.oppAccountNo &&
          this.paramsData.verifyCode &&
          this.selectedMerchant;
      if (this.payType === 'BALANCE') {
        return base && this.paymentValue;
      }
      // TAX_PLAN：基础条件 + 限额校验通过（或未触发校验）
      // 当金额已输入且已触发校验，limitCheckOk 必须为 true
      const amount = Number(this.paramsData.totalAmount);
      const limitValid = !amount || amount <= 0 ? true : this.limitCheckOk;
      return base && limitValid;
    },
    /**
     * 按钮禁用原因（用于 tooltip 提示）
     */
    disabledReason() {
      if (this.submitting) return '提交中...';
      if (!this.selectedMerchant) return '请先选择税筹商户';
      if (!this.paramsData.totalAmount) return '请输入订单金额';
      if (!this.paramsData.oppAccountNo) return '请选择收款人';
      if (!this.paramsData.verifyCode) return '请填写验证码';
      if (this.payType === 'BALANCE' && !this.paymentValue) return '请选择付款协议';
      // 税筹支付：限额校验失败
      if (this.payType === 'TAX_PLAN' && this.limitCheckMsg && !this.limitCheckOk) {
        return this.limitCheckMsg;
      }
      return '';
    },
    calculatedServiceFee() {
      if (!this.paramsData.totalAmount || !this.selectedMerchant?.feeRuleNo) {
        return '0.00';
      }
      const feeRule = this.feeRuleList.find(f => f.feeNo === this.selectedMerchant.feeRuleNo);
      if (!feeRule) return '0.00';
      const amount = parseFloat(this.paramsData.totalAmount) || 0;
      const rate = parseFloat(feeRule.feeRate) || 0;
      return (amount * rate).toFixed(2);
    },
  },

  mounted() {
    this.loadFeeRules();
  },
  beforeDestroy() {
    if (this.limitCheckTimer) {
      clearTimeout(this.limitCheckTimer);
      this.limitCheckTimer = null;
    }
  },
  watch: {
    /**
     * 监听订单金额变化（税筹支付场景下做实时限额预校验）
     * 防抖 500ms 避免每次输入都请求
     */
    'paramsData.totalAmount': {
      handler(val) {
        if (this.payType !== 'TAX_PLAN' || !this.selectedMerchant) {
          return;
        }
        const amount = Number(val);
        if (!amount || amount <= 0) {
          this.limitCheckMsg = '';
          this.limitCheckOk = false;
          this.limitCheckStatus = '';
          return;
        }
        if (this.limitCheckTimer) {
          clearTimeout(this.limitCheckTimer);
        }
        this.limitCheckMsg = '校验中...';
        this.limitCheckOk = false;
        this.limitCheckStatus = '';
        this.limitCheckTimer = setTimeout(() => {
          this.doCheckLimit(false);
        }, 500);
      },
    },
    /**
     * 商户或支付类型变化时立即重检
     */
    selectedMerchant: {
      handler() {
        if (this.payType === 'TAX_PLAN' && this.paramsData.totalAmount) {
          this.doCheckLimit(false);
        }
      },
    },
    payType(val) {
      if (val === 'TAX_PLAN' && this.paramsData.totalAmount) {
        this.doCheckLimit(false);
      } else {
        this.limitCheckMsg = '';
        this.limitCheckOk = false;
        this.limitCheckStatus = '';
      }
    },
  },

  methods: {
    async loadFeeRules() {
      try {
        const res = await this.api.getCommisionFeeRuleApi({});
        if (res.code === 200) {
          this.feeRuleList = res.data.filter(item => item.feeType === '2') || [];
        }
      } catch (e) {
        console.error('加载服务费规则失败', e);
      }
    },

    openMerchantDialog() {
      this.merchantDialogVisible = true;
      this.loadMerchantList();
    },

    searchMerchant() {
      this.merchantPagination.current = 1;
      this.loadMerchantList();
    },

    resetMerchantSearch() {
      this.merchantSearchParam = {merchantNo: "", merchantName: ""};
      this.merchantPagination.current = 1;
      this.loadMerchantList();
    },

    async loadMerchantList() {
      this.merchantLoading = true;
      try {
        const res = await this.api.getMerchantConfigList({
          ...this.merchantSearchParam,
          pageNo: this.merchantPagination.current,
          pageSize: this.merchantPagination.pageSize,
          recordStatus: '0',
        });
        if (res.code === 200) {
          this.merchantList = res.data.records || [];
          this.merchantPagination.total = res.data.total || 0;
        }
      } catch (e) {
        console.error('获取商户列表失败', e);
      } finally {
        this.merchantLoading = false;
      }
    },

    handleMerchantTableChange(pagination) {
      this.merchantPagination.current = pagination.current;
      this.merchantPagination.pageSize = pagination.pageSize;
      this.loadMerchantList();
    },

    selectMerchant(merchant) {
      console.log("selectedMerchant", merchant)
      this.selectedMerchant = merchant;
      this.selectedMerchantName = merchant.merchantName;

      this.paramsData.channelNo = merchant.channelNo;
      this.paramsData.appNo = merchant.appNo;

      this.payType = 'TAX_PLAN';
      this.applyPayType();
      this.merchantDialogVisible = false;
    },

    onPayTypeChange() {
      this.paymentValue = undefined;
      this.paymentList = [];
      this.payerValue = undefined;
      this.payerAccountList = [];
      this.paramsData.oppAccountNo = '';
      this.paramsData.oppAccountName = '';
      this.paramsData.oppBankNo = '';
      this.paramsData.oppBankName = '';
      this.applyPayType();
    },

    onPayerChange(value) {
      if (!value) return;
      const payer = this.payerAccountList.find(item => item.accountNo === value);
      if (!payer) return;
      this.paramsData.accountNo = payer.accountNo;
      this.paramsData.accountName = payer.accountName;
      this.paymentValue = undefined;
      this.paymentList = [];
      this.paramsData.oppAccountNo = '';
      this.paramsData.oppAccountName = '';
      this.paramsData.oppBankNo = '';
      this.paramsData.oppBankName = '';
      this.getAvibaleBalance();
      this.getPaymentList();
      // 余额支付：付款账户变更立即触发一次填充（balance 是旧值时 fillBalanceDefaultAmount 内部会拦截），
      // 等 getAvibaleBalance 异步返回新余额后再覆盖一次
      if (this.payType === 'BALANCE') {
        this.fillBalanceDefaultAmount();
      }
    },

    applyPayType() {
      const merchant = this.selectedMerchant;
      if (!merchant) return;

      if (this.payType === 'BALANCE') {
        // 余额支付：付款人下拉可选个体户账户 / 清分户
        this.paramsData.oppAccountType = '';

        this.payerAccountList = [
          {accountNo: merchant.accountNo, accountName: merchant.accountName, label: '个体户账户'},
          {accountNo: merchant.settleAccountNo, accountName: merchant.settleAccountName, label: '待清算账户'},
        ];

        // 默认选中个体户账户
        this.payerValue = merchant.accountNo;
        this.paramsData.accountNo = merchant.accountNo;
        this.paramsData.accountName = merchant.accountName;

        this.payerWalletList = [{
          accountClass: '0',
          accountNo: merchant.accountNo
        }];

        this.getAvibaleBalance();
        this.getPaymentList();
        this.fillBalanceDefaultAmount();
      } else {
        // 税筹支付：原逻辑
        this.paramsData.accountNo = merchant.settleAccountNo;
        this.paramsData.accountName = merchant.settleAccountName;

        this.paramsData.oppAccountNo = merchant.accountNo;
        this.paramsData.oppAccountName = merchant.accountName;
        this.paramsData.oppBankNo = "313338707013";
        this.paramsData.oppBankName = "浙江稠州商业银行";
        this.paramsData.remark = merchant.taxRemark;

        this.payerWalletList = [{
          accountClass: '0',
          accountNo: merchant.accountNo
        }];

        this.getAvibaleBalance();
      }
    },

    /**
     * 余额支付：按商户配置比例 × 可用余额 填充订单金额
     * 商户未配 balancePayRate 时不自动填充；用户后续仍可自由修改
     */
    fillBalanceDefaultAmount() {
      const merchant = this.selectedMerchant;
      if (!merchant) {
        console.warn('[fillBalanceDefaultAmount] 无选中商户');
        return;
      }
      const rate = merchant.balancePayRate;
      const balance = Number(this.balance) || 0;
      console.log('[fillBalanceDefaultAmount]', {
        merchantNo: merchant.merchantNo,
        balancePayRate: rate,
        balance: this.balance,
      });
      if (rate === null || rate === undefined || rate === '') {
        console.warn('[fillBalanceDefaultAmount] 商户未配置 balancePayRate，无法自动填充');
        return;
      }
      if (balance <= 0) {
        console.warn('[fillBalanceDefaultAmount] 余额为 0，跳过填充');
        return;
      }
      const amount = Math.floor(balance * Number(rate) * 100) / 100;
      this.paramsData.totalAmount = amount > 0 ? amount.toFixed(2) : '0.01';
    },


    async getAvibaleBalance() {
      if (!this.paramsData.accountNo) return;
      try {
        const res = await this.api.avibaleBalanceApi({
          channel_no: this.paramsData.channelNo,
          account_no: this.paramsData.accountNo,
          relation_acct: 1
        });
        if (res.code == 200) {
          this.mobile_mch = res.data.mobile;
          const acctList = res.data.detail_list.find(
              (acct) => acct.account_no === this.paramsData.accountNo
          );
          this.balance = acctList?.cur_balance || 0;
          // 余额支付：余额异步返回后按比例填充订单金额
          if (this.payType === 'BALANCE') {
            this.fillBalanceDefaultAmount();
          }
        }
      } catch (e) {
        console.error('获取余额失败', e);
      }
    },

    async getPaymentList() {
      if (!this.paramsData.accountNo) return;
      this.paymentLoading = true;
      try {
        const res = await this.api.getPayProtocolListApi({
          pageNo: 1,
          pageSize: 10000,
          obj: {accountNo: this.paramsData.accountNo}
        });
        if (res.code === 200) {
          this.paymentList = res.data.records || [];
          const defaultOppAcct = this.paymentList.find((item) => item.checkStatus === '1');
          if (defaultOppAcct) {
            this.paymentValue = defaultOppAcct.id;
            this.paymentChange(defaultOppAcct.id);
          }
        }
      } catch (e) {
        console.error('获取收款人列表失败', e);
      } finally {
        this.paymentLoading = false;
      }
    },

    paymentChange(value) {
      if (!value) return;
      const paymentData = this.paymentList.find((item) => item.id == value) || {};
      this.paramsData.oppAccountType = paymentData.oppAccountType;
      this.paramsData.oppAccountNo = paymentData.oppAccountNo;
      this.paramsData.oppAccountName = paymentData.oppAccountName;
      this.paramsData.oppBankNo = paymentData.oppBankNo || "313338707013";
      this.paramsData.oppBankName = paymentData.oppBankName || "浙江稠州商业银行";
      this.paramsData.remark = '';
    },

    onSubmitPay() {
      if (!this.selectedMerchant) {
        return this.$message.error("请选择税筹商户");
      }
      if (!this.paramsData.totalAmount) {
        return this.$message.error("请输入订单金额");
      }
      if (!this.paramsData.verifyCode) {
        return this.$message.error("请填写验证码");
      }
      // 税筹支付先预校验商户限额（避免后端拒绝）
      if (this.payType === 'TAX_PLAN') {
        this.doCheckLimit(true).then(() => {
          if (this.limitCheckOk) {
            this.isShowConfirmDialog = true;
          }
        });
      } else {
        this.isShowConfirmDialog = true;
      }
    },

    /**
     * 预校验商户限额
     * @param showError 是否弹错误消息。false=静默（用于实时校验），true=弹错误（用于点击提交时）
     */
    async doCheckLimit(showError = true) {
      if (!this.selectedMerchant) return;
      const amount = Number(this.paramsData.totalAmount);
      if (!amount || amount <= 0) {
        this.limitCheckMsg = '';
        this.limitCheckOk = false;
        this.limitCheckStatus = '';
        return;
      }
      this.limitChecking = true;
      try {
        const res = await this.api.checkOrderLimit({
          merchantNo: this.selectedMerchant.merchantNo,
          totalAmount: amount,
        });
        const data = res.data || {};
        const status = data.status || (res.code === 200 ? 'PASS' : 'FAIL');
        const msg = data.message || res.info || '';
        this.limitCheckStatus = status;

        if (status === 'PASS') {
          this.limitCheckOk = true;
          this.limitCheckMsg = msg || '✓ 限额校验通过';
        } else if (status === 'WARN') {
          this.limitCheckOk = true; // WARN 仍允许下单
          this.limitCheckMsg = msg || '⚠ 已达限额警戒线';
        } else {
          // FAIL
          this.limitCheckOk = false;
          this.limitCheckMsg = msg || '✗ 商户限额超出';
          if (showError) {
            this.$message.error(this.limitCheckMsg);
          }
        }
      } catch (e) {
        console.error('限额校验异常', e);
        this.limitCheckMsg = '✗ 限额校验请求失败';
        this.limitCheckOk = false;
        this.limitCheckStatus = 'FAIL';
        if (showError) {
          this.$message.error('限额校验请求失败');
        }
      } finally {
        this.limitChecking = false;
      }
    },

    onConfirmDialog() {
      this.isShowConfirmDialog = false;
      this.doCreateOrder();
    },

    async doCreateOrder() {
      this.submitting = true;
      try {
        const data = {
          merchantNo: this.selectedMerchant.merchantNo,

          accountNo: this.paramsData.accountNo,
          accountName: this.paramsData.accountName,

          oppAccountNo: this.paramsData.oppAccountNo,
          oppAccountName: this.paramsData.oppAccountName,
          oppAccountType: this.paramsData.oppAccountType || '1',
          oppBankNo: this.paramsData.oppBankNo,
          oppBankName: this.paramsData.oppBankName,
          totalAmount: Number(this.paramsData.totalAmount),
          remark: this.paramsData.remark,
          verifyCode: this.paramsData.verifyCode,
          payType: this.payType,
        };
        const res = await this.api.createOrder(data);
        if (res.code == 200) {
          this.$message.success(res.info || '订单创建成功');
          this.resetForm();
          this.$router.push({path: "/tax/order"});
        } else {
          this.$message.error(res.info || '订单创建失败');
        }
      } catch (e) {
        console.error('订单创建失败', e);
        this.$message.error('订单创建请求异常');
      } finally {
        this.submitting = false;
      }
    },

    resetForm() {
      this.paramsData = {
        channelNo: "", appNo: "", accountNo: "", accountName: "",
        custname: "", oppAccountType: "", oppAccountNo: "", oppAccountName: "",
        oppBankNo: "313338707013", oppBankName: "浙江稠州商业银行",
        verifyCode: "", totalAmount: "", remark: "",
      };
      this.selectedMerchant = null;
      this.selectedMerchantName = '';
      this.payType = 'TAX_PLAN';
      this.balance = 0;
      this.paymentList = [];
      this.paymentValue = undefined;
      this.payerAccountList = [];
      this.payerValue = undefined;
    },
  }
}
</script>

<style lang="less" scoped>
.title-box {
  display: flex;
  justify-content: space-between;
}

.form-box {
  padding: 50px;

  .form-box-item {
    margin-bottom: 20px;

    .account-tag {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 4px 12px;
      background: #f5f5f5;
      border-radius: 4px;
    }

    .ant-input {
      max-width: 300px;
    }

    .payment-box {
      width: 450px;
      margin-top: 10px;
    }

    .required::before {
      content: '*';
      color: #ff4d4f;
      margin-right: 4px;
    }
  }
}

.merchant-search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.merchant-display {
  display: inline-block;
  min-width: 200px;
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
}

.limit-check-tip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  margin-left: 8px;
  padding: 4px 12px;
  font-size: 13px;
  border-radius: 4px;
  background: #f5f5f5;
  color: #999;

  &.pending {
    color: #1890ff;
    background: #e6f7ff;
    border: 1px solid #91d5ff;
  }

  &.pass {
    color: #52c41a;
    background: #f6ffed;
    border: 1px solid #b7eb8f;
  }

  &.warn {
    color: #fa8c16;
    background: #fff7e6;
    border: 1px solid #ffd591;
    font-weight: 500;
  }

  &.fail {
    color: #ff4d4f;
    background: #fff1f0;
    border: 1px solid #ffa39e;
  }
}
</style>